import './Portal.css';

import Menu from '../Menu';
import Unreachable from '../Unreachable';
import Register from '../Register';
import TestOrganization from '../TestOrganization';
import PrivacyPolicy from '../../components/PrivacyPolicy';

import SessionActions from '../../actions/SessionActions';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Switch, Route} from 'react-router-dom';
import {connect} from 'react-redux';

import Login from '../Login';

export const CREATE_TEST_ORGANIZATION_PATH = 'create-test-organization';
const REGISTER_PATH = 'register';

const mapStateToProps = store => ({
  invalidSession: store.session.invalidSession,
});

const mapDispatchToProps = dispatch => ({
  ...SessionActions.bindActions(dispatch),
});

class Portal extends Component {
  static propTypes = {
    history: PropTypes.shape({
      location: PropTypes.shape({
        pathname: PropTypes.string,
      }),
    }),
    invalidSession: PropTypes.bool.isRequired,
    VALIDATE: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  componentDidMount() {
    this.props.VALIDATE(this);
  }

  openPrivacyPolicy() {
    window.open('https://dized.com/privacy-policy/', '_blank');
  }

  render() {
    return (
      <div className="Portal">
        <div className="Portal-body">
          <div className="Portal-content">
            <Switch>
              <Route exact path="/" component={Unreachable} />
              <Route exact path={`/${CREATE_TEST_ORGANIZATION_PATH}`} component={TestOrganization} />
              <Route path={`/${REGISTER_PATH}`} component={Register} />
              <Route path="/:orgName/login" component={Login} />
              {/* NOTE: this must be last */}
              <Route path="/:orgName" component={Menu} />
            </Switch>
          </div>
        </div>
        <PrivacyPolicy />
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Portal);
